import { UseControllerProps } from 'react-hook-form'
import isEmpty from 'lodash/isEmpty'

import { Validations } from 'common/interfaces'

export default function validationsToRules(validations: Validations): UseControllerProps['rules'] {
  return {
    required: validations.required,
    min: validations.min,
    max: validations.max,
    minLength: validations.minLength,
    maxLength: validations.maxLength,
    pattern:
      validations.pattern !== undefined
        ? {
            value: new RegExp(validations.pattern.value),
            message: validations.pattern.message,
          }
        : undefined,
    validate: {
      equal: (value) => {
        if (validations?.equal === undefined) {
          return true
        }

        const { message } = validations.equal

        if (Array.isArray(validations.equal.value)) {
          return validations.equal.value.includes(value) || message
        } else {
          return validations.equal.value === value || message
        }
      },
    },
  }
}

export function validationsToMapRules(validations: Validations): UseControllerProps['rules'] {
  return {
    validate: {
      required: (fieldValue) => {
        if (validations?.required === undefined) {
          return true
        }

        const { value, message } = validations.required

        return !value || !isEmpty(fieldValue) || message
      },
    },
  }
}

export function validationsToAxleIframeRules(
  validations: Validations
): UseControllerProps['rules'] {
  return {
    validate: {
      required: (fieldValue: any) => {
        // If 'required' validation is not defined, allow it to pass
        if (validations?.required === undefined) {
          return true
        }

        const { value: isRequired, message: requiredMessage } = validations.required

        if (!isRequired) {
          return true
        }

        if (isEmpty(fieldValue)) {
          return requiredMessage || 'This field is required'
        }

        // Validate axleStatus, account, and policy only when the field is required
        if (
          (fieldValue.axleStatus !== 'connected' && fieldValue.axleStatus !== 'exited') ||
          (fieldValue.axleStatus === 'connected' && (!fieldValue.account || !fieldValue.policy))
        ) {
          return requiredMessage || 'Please connect your Axle account or exit Axle setup'
        }

        // If all checks pass, return true
        return true
      },
    },
  }
}

export function validationToCheckboxRules(validations: Validations): UseControllerProps['rules'] {
  return {
    validate: {
      required: (value) => {
        if (validations?.required === undefined) {
          return true
        }

        const { message } = validations.required
        const hasChecked = Object.values(value as Record<string, boolean>).some((val) => val)

        return !validations.required.value || hasChecked || message
      },
      min: (value) => {
        if (validations?.min === undefined) {
          return true
        }

        const { message, value: min } = validations.min
        const count = Object.values(value as Record<string, boolean>).filter((val) => val).length

        return count >= min || message
      },
      max: (value) => {
        if (validations?.max === undefined) {
          return true
        }

        const { message, value: max } = validations.max
        const count = Object.values(value as Record<string, boolean>).filter((val) => val).length

        return count <= max || message
      },
    },
  }
}
